// Tracks which tour_key is currently running so the lifecycle controller can
// attribute completion/skip events to it. reactour doesn't carry a tour key, so
// we hold it here. Single-instance app; only read inside effects.

let activeTourKey: string | null = null;

export const setActiveTourKey = (key: string | null): void => {
	activeTourKey = key;
};

export const getActiveTourKey = (): string | null => activeTourKey;
